export default __webpack_public_path__ + "static/media/mc-cormick-mc-120.4943fa49.jpg";